import { LifeBuoy, ShieldCheck } from 'lucide-react';
import { DiscordTemplateKey } from '@/Domain/api/Action/dto/DiscordTemplate.dto';
import {
  ActionTemplate,
  ActionTemplateCategory,
} from '@/Domain/components/Action/actionTemplate.types';
import { HttpMethodEnum } from '@/Domain/enum/HttpMethod.enum';

export type DiscordObjectCategory = 'support' | 'moderation';

export type DiscordTemplate = {
  id: string;
  installKey: DiscordTemplateKey;
  category: DiscordObjectCategory;
  nameKey: string;
  descriptionKey: string;
  method: HttpMethodEnum;
  requiresConfiguration?: boolean;
};

export type DiscordCategory = ActionTemplateCategory<DiscordObjectCategory>;

export const DISCORD_CATEGORIES: DiscordCategory[] = [
  { id: 'support', icon: LifeBuoy, labelKey: 'discord_templates.category.support' },
  { id: 'moderation', icon: ShieldCheck, labelKey: 'discord_templates.category.moderation' },
];

export const DISCORD_TEMPLATES: DiscordTemplate[] = [
  {
    id: 'support_ticket',
    installKey: 'support_ticket',
    category: 'support',
    nameKey: 'discord_templates.template.open_support_ticket.name',
    descriptionKey: 'discord_templates.template.open_support_ticket.description',
    method: HttpMethodEnum.POST,
    requiresConfiguration: true,
  },
  {
    id: 'timeout_member',
    installKey: 'timeout_member',
    category: 'moderation',
    nameKey: 'discord_templates.template.timeout_member.name',
    descriptionKey: 'discord_templates.template.timeout_member.description',
    method: HttpMethodEnum.PATCH,
  },
  {
    id: 'kick_member',
    installKey: 'kick_member',
    category: 'moderation',
    nameKey: 'discord_templates.template.kick_member.name',
    descriptionKey: 'discord_templates.template.kick_member.description',
    method: HttpMethodEnum.DELETE,
  },
  {
    id: 'ban_member',
    installKey: 'ban_member',
    category: 'moderation',
    nameKey: 'discord_templates.template.ban_member.name',
    descriptionKey: 'discord_templates.template.ban_member.description',
    method: HttpMethodEnum.PUT,
  },
  {
    id: 'unban_member',
    installKey: 'unban_member',
    category: 'moderation',
    nameKey: 'discord_templates.template.unban_member.name',
    descriptionKey: 'discord_templates.template.unban_member.description',
    method: HttpMethodEnum.DELETE,
  },
  {
    id: 'assign_role',
    installKey: 'assign_role',
    category: 'moderation',
    nameKey: 'discord_templates.template.assign_role.name',
    descriptionKey: 'discord_templates.template.assign_role.description',
    method: HttpMethodEnum.PUT,
  },
  {
    id: 'set_slowmode',
    installKey: 'set_slowmode',
    category: 'moderation',
    nameKey: 'discord_templates.template.set_slowmode.name',
    descriptionKey: 'discord_templates.template.set_slowmode.description',
    method: HttpMethodEnum.PATCH,
  },
  {
    id: 'send_announcement',
    installKey: 'send_announcement',
    category: 'moderation',
    nameKey: 'discord_templates.template.send_announcement.name',
    descriptionKey: 'discord_templates.template.send_announcement.description',
    method: HttpMethodEnum.POST,
  },
];

export const DISCORD_SCRATCH_TEMPLATE: ActionTemplate = {
  id: 'scratch',
  category: 'support',
  nameKey: 'discord_templates.start_from_scratch',
  descriptionKey: 'discord_templates.start_from_scratch_description',
  aiDescription: '',
  thinkingMessage: '',
  method: HttpMethodEnum.GET,
  url: '',
  headers: [{ name: 'Authorization', value: 'Bot {{discord_bot_token}}' }],
  bodyJson: JSON.stringify({}, null, 2),
  queryItems: [],
  parameters: [],
};
